var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 25,
    viewBox: "0 0 45 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.1411 7.40223V5.58659L9.66258 0H23.1902V1.53631L17.3926 7.40223H4.1411Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.773 9.63687H5.65951L0 15.3631V17.4581H13.2515L18.773 11.8715L31.7485 25H45V23.1844L32.7147 10.7542L38.3742 5.02793V3.21229H25.1227L18.773 9.63687Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoicon);
export default __webpack_public_path__ + "static/media/logoicon.b890c2ea808535c47c947fd749845eac.svg";
export { ForwardRef as ReactComponent };